import { defineStore } from "pinia";
import { useApi } from "@js/api/gql";
import { ref, unref, watch, computed, type Ref } from "vue";
import { formatFilters } from '@js/helpers/filters';
import { pimFiltersQuery } from "../queries";
// import { useProductsStore } from "../stores/products";
const initialFilters = {
  productStyle: null,
  productType: null,
  productModel: null,
  buildingType: null,
  numBedrooms: null,
  footprint: null,
  usableArea: null,
  maxLength: null,
  maxWidth: null,
  plotType: null,
  roofType: null,
  numLevels: null,
  productProperties: null,
  regulations: null,
  productStatus: null,
}

export const useFiltersStore = defineStore("filters", () => {
  const filterSections: Ref<ProductFilterSection[] | null> = ref(null);
  const filterData: Ref<ProductFilterData | null> = ref(null)
  const searchQuery: Ref<string | null> = ref(null);
  const filters = ref({ ...initialFilters });
  const order: Ref<string | null> = ref("usableArea ASC");

  // const productsStore = useProductsStore();

  const filterList = useApi(
    (query: string, variables: any) => ({
      query,
      variables,
    }),
    (r: any) => r.data.data,
  );

  async function getFilters(init: boolean = false) {
    const queryFilters = formatFilters(unref(filters));
    const data = await filterList.execute(pimFiltersQuery, {
      search: searchQuery.value,
      ...queryFilters,
    });

    filterSections.value = data.filterSections;
    filterData.value = data;

    if (init) {
      filterSections.value?.forEach(section => {
        if (section.defaultValue.length) {
          filters.value[section.productFieldHandle] = section.defaultValue;
        }
      })
      // productsStore.getProducts();
    }
  }

  const isAnyFilterActive = computed(() => {
    for (const value of Object.values(filters.value)) {
      if (value !== null) {
        return true;
      }
    }
    return false;
  });

  function resetFilter(key: string) {
    filters.value[key] = null;
  }

  function resetAllFilters() {
    searchQuery.value = null;
    Object.assign(filters.value, initialFilters);
  }

  return {
    searchQuery,
    order,
    filters,
    filterData,
    filterSections,
    resetFilter,
    resetAllFilters,
    isAnyFilterActive,
    isLoading: filterList.isLoading,
    error: filterList.error,
    getFilters,
  };
});
